import { RouteLocationNormalized } from 'vue-router'
import Bugsnag from '@bugsnag/js'
import { env } from '@/lib/runtimeEnv'

export let resolvePromo
const waitForPromo = new Promise(res => {
  resolvePromo = res
})

window.addEventListener('gotPromo', function (e) {
  resolvePromo(e)
})

const trackPageView = (
  to: RouteLocationNormalized,
  from?: RouteLocationNormalized,
  forceWaitForPromo = false
) => {
  const name = to.name || to.path
  const { pathname, href } = window.location

  const properties = {
    url: href,
    path: pathname,
  }

  const goingToPlans = forceWaitForPromo || pathname.includes('/plan')

  if (goingToPlans) {
    waitForPromo.then((e: any) => {
      const promoId = e.detail.promoId

      if (promoId) {
        Object.assign(properties, {
          promoId,
        })
      }

      track()
    })
  } else {
    track()
  }

  function track() {
    // @ts-ignore
    if (!window.rudderanalytics && env.VITE_BUGSNAG_KEY) {
      Bugsnag.notify('window.rudderanalytics is not defined when tracking page')
    }

    window.rudderanalytics &&
      window.rudderanalytics.page(name as string, properties)
  }
}

export default trackPageView
